import {Fragment} from 'react';
import EventLineV4 from './EventLineV4';
import EventMaxWidthV4 from './EventMaxWidthV4';
import RewardItemV4 from './RewardItemV4';
import RewardProgressBarV4 from './RewardProgressBarV4';
import {IRewardModuleV4} from '../type';

interface IProps {
  data: IRewardModuleV4;
}

export default function RewardModuleV4({data}: IProps) {
  const {progressBar} = data;
  return (
    <div
      className="py-15 bg-gradient-to-b from-black/15 to-black/15"
      data-module-type="reward"
    >
      <EventMaxWidthV4>
        {progressBar && <RewardProgressBarV4 progressBar={progressBar} />}
        {data.rewardList?.map((item, index) => (
          <Fragment key={index}>
            {index > 0 && <EventLineV4 className="my-10 opacity-10" />}
            <RewardItemV4 item={item} isEmphasis={data.isEmphasis} />
          </Fragment>
        ))}
      </EventMaxWidthV4>
    </div>
  );
}
